import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarmElement,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P00080Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('alSAlarm') === 1) {
    if ((getValue('alSSwitchK2Debit') & 1) === 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.general.sourcedebit',
      });
    }

    if (getValue('alSEtatRxBottomOfTank') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.bidon.rx',
      });
    }

    if (getValue('alSEtatPhBottomOfTank') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.bidon.ph',
      });
    }
    if (getValue('alSEtatRxMaxDosingTime') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.bidon.surdosagerx',
      });
    }

    if (getValue('alSEtatPhMaxDosingTime') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.bidon.surdosageph',
      });
    }

    if (getValue('alSEtatRxLowAlarmThresholdCrossed') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.desinfection.rx.mesure.low',
      });
    }

    if (getValue('alSEtatRxHighAlarmThresholdCrossed') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.desinfection.rx.mesure.high',
      });
    }

    if (getValue('alSEtatPhLowAlarmThresholdCrossed') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.desinfection.ph.mesure.low',
      });
    }

    if (getValue('alSEtatPhHighAlarmThresholdCrossed') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.desinfection.ph.mesure.high',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CLPH,
        functionalityTitle: 'dashboard.clph',
        title: 'P00080.status.connexionProduit',
      });
    }
  }

  return res;
}
